import { DatePipe } from "@angular/common";
import {
  Component,
  Injectable,
  Input,
  OnInit,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Params } from "@angular/router";
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { AppVehicleComponent } from "app/permits/permit-application/shared/app-vehicle/app-vehicle.component";
import { ApplicationService } from "app/services/application.service";
import { PermitService } from "app/services/permit.service";
import { VehicleService } from "app/services/vehicle.service";
import { environment } from "environments/environment";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { accounting } from "accounting";
import { CarrierService } from "app/services/carrier.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = "/";

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DT_FORMAT = "DD/MM/YYYY";

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt = moment(value, this.DT_FORMAT);
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!date) return "";
    let mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return "";
    return mdt.format(this.DT_FORMAT);
  }
}
@Component({
  selector: "app-modify-details",
  templateUrl: "./modify-details.component.html",
  styleUrls: ["./modify-details.component.scss"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class ModifyDetailsComponent implements OnInit {
  currentDate: any = {
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  }; //{ day: "?= date('Y-m-d'); ?" } //
  isEditDate = false;
  route_detail = "This the details of the route";
  quillConfig = {
    //toolbar: '.toolbar',
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        //['code-block'],
        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction

        //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        //[ 'header'],

        ["clean"], // remove formatting button

        ["link"],
        ["link", "image", "video"],
      ],
    },
  };
  max_limit: number = 14;
  totalFee: number = 0;

  form: FormGroup = this.formBuilder.group({
    route_detail: ["", [<any>Validators.required]],
  });
  pageload: boolean;
  listvehicles: any;
  appData: any;
  @Input() dataCntrl: any;
  @Input() routeDetials: any;
  @ViewChildren(AppVehicleComponent) vehicleComponent: AppVehicleComponent;
  money: string = "color: red";

  constructor(
    private carrierService: CarrierService,
    private toastr: ToastrService,
    private toastService: ToastNotificationService,
    private permitSevc: PermitService,
    private vehicleService: VehicleService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params: Params) => {
      if (params["id"]) {
        console.log(params["id"]);
        this.getApplicationDetails(params["id"]);
      }
    });
  }
  setCarrierData(data) {
    // Account Balance
    data.account_balance = data.account_balance * -1;
    let colr = data.account_balance > 0 ? "green" : "red";
    document.getElementById("Money").style.color = colr;
    data.account_balance =
      data.account_balance == 0
        ? "R 0.00"
        : this.formatCurrency(data.account_balance);

    this.dataCntrl.carrier = data;
    console.log(this.dataCntrl.carrier);
  }
  getApplicationDetails(id) {
    this.applicationService.getById(id).subscribe((x) => {
      this.appData = x;
      this.dataCntrl = x;
      console.log(this.appData);
      this.setCarrierData(this.appData.carrier);
      this.form.value.route_detail = this.appData.route_detail;
      this.intializeVehicles();
    });
  }
  ngAfterViewInit() {}
  initForm() {}
  formatCurrency(value) {
    return accounting.formatMoney(value, "R", 2, " ", ".");
  }
  created(event: any) {}
  editDate() {
    this.isEditDate = !this.isEditDate;
  }
  editVehicle(item) {
    const index: number = this.listvehicles.indexOf(item);
    if (index !== -1) {
      this.listvehicles[index].editMode = true;
    }
  }
  updatePermitStartDate(permit, noOfDays) {
    this.permitSevc.putAppPermit(permit, noOfDays).subscribe((result) => {
      setTimeout(() => {
        this.intializeVehicles();
      }, 400);
    });
  }
  updatePermit(result) {
    this.permitSevc.upadatePermit(result).subscribe((res) => {});
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  intializeVehicles() {
    this.permitSevc.getAllPermitsByApplicationId(this.appData.id).subscribe(
      (data: any) => {
        // //console.log(data.filter(i => i.application_id == this.appData.application.id));
        // let permits = data.filter(i => i.application_id == this.appData.application.id);
        let permits = data;
        this.vehicleService.getPermitsAppVecle(this.appData.id).subscribe(
          (x: any) => {
            this.listvehicles = [];
            if (permits.length > 0) {
              for (let p = 0; p < permits.length; p++) {
                //console.log(permits[p].id)
                let perm = permits[p];
                //console.log(x.filter(i => i.permit_id == permits[p].id))
                let allVeh = x.filter((i) => i.permit_id == perm.id);

                //console.log(x.find(i => i.permit_id == permits[p].id))

                if (allVeh.length > 0) {
                  for (let v = 0; v < allVeh.length; v++) {
                    let vehicles = allVeh[v];
                    let object = {
                      id: vehicles.id,
                      vehicle_type_id: vehicles.vehicle_type_id,
                      vehicle_make_id: vehicles.vehicle_make_id,
                      vehicle_make: vehicles.vehicle_make,
                      vehicle_type: vehicles.vehicle_type,
                      is_current: false,
                      registration_number: vehicles.registration_number,
                      // seating_capacity:vehicles.seating_capacity,
                      permit_id: vehicles.permit_id,
                      number_passengers:
                        vehicles.number_passengers > 0
                          ? vehicles.number_passengers
                          : vehicles.seating_capacity,
                      seating_capacity: vehicles.seating_capacity,
                      gvn: vehicles.gvn,
                      vin: vehicles.vin,
                      date_license_expiry: this.datePipe.transform(
                        vehicles.date_license_expiry,
                        "dd/MM/yyyy"
                      ),
                      start_date: this.datePipe.transform(
                        vehicles.start_date,
                        "dd/MM/yyyy"
                      ),
                      editMode: false,
                      withoutVehicle: vehicles.vin == null ? true : false,
                      permit_num: perm.permit_num,
                      application_fee: perm.application_fee,
                      permit_fee: perm.permit_fee,
                      lineTotal: perm.application_fee + perm.permit_fee,
                    };
                    this.totalFee += object.lineTotal;

                    let permitData: any = permits.filter((map) => {
                      return map.id == vehicles.permit_id;
                    });
                    let days: any = this.appData.permit_type.permit_days;
                    if (permitData != null && permitData.length > 0) {
                      if (
                        permitData[0].date_valid_from != null &&
                        permitData[0].date_valid_to != null
                      ) {
                        let from_date: any = new Date(
                          permitData[0].date_valid_from
                        );
                        let to_date: any = new Date(
                          permitData[0].date_valid_to
                        );

                        if (from_date != undefined && to_date != undefined) {
                          days = Math.floor(
                            (Date.UTC(
                              to_date.getFullYear(),
                              to_date.getMonth(),
                              to_date.getDate()
                            ) -
                              Date.UTC(
                                from_date.getFullYear(),
                                from_date.getMonth(),
                                from_date.getDate()
                              )) /
                              (1000 * 60 * 60 * 24)
                          );
                          //console.log("------+" + days);
                        }
                      }
                    }

                    object["noOfDays"] = days;
                    // if (this.renewalFlag == true && loadType == 'load') {
                    //   object.id = -1;
                    // }
                    //console.log(object)
                    //   if(this.listvehicles.length === data.vehicle.length){
                    // //console.log('Its 0')
                    //  this.listvehicles = this.appData.vehicles ;
                    //  this.pageload = false;

                    // return;
                    //   }

                    this.listvehicles.push(object);
                    this.pageload = false;

                    this.listvehicles.sort(function (a, b) {
                      if (a.id < b.id) {
                        return -1;
                      }
                      if (a.id > b.id) {
                        return 1;
                      }
                      return 0;
                    });

                    // }, error => {
                    //   this.pageload = false;
                    //   //console.log(this.listvehicles);
                    //   this.appData.vehicles = this.listvehicles;
                    // })
                  }
                }
                this.pageload = false;
              }
              console.log(this.listvehicles);
            } else {
              this.pageload = false;
              //console.log(this.listvehicles);
            }

            // this.newListvehicles.push(x)
            //  //console.log(this.newListvehicles)
            //  this.appData.vehicles = this.newListvehicles
            // //  this.listvehicles = this.appData.vehicles;
          },
          (error) => {
            this.pageload = false;
            //console.log(this.listvehicles);
          }
        );
      },
      (error) => {
        this.pageload = false;
        //console.log(this.listvehicles);
      }
    );
  }
  saveVehicle(item, getIndex) {
    // console.log('index: '+getIndex);
    // console.log(item);
    // return
    // this.getVehicleType();
    // let expiryDate:any=""
    // if(item.date_license_expiry!=null && item.date_license_expiry!=""){
    //   expiryDate=item.date_license_expiry.split("-")[2]+"/"+item.date_license_expiry.split("-")[1]+"/"+item.date_license_expiry.split("-")[0];
    // }
    // let startDate:any=""
    // if(item.start_date!=null && item.start_date!=""){
    //   startDate=item.start_date.split("-")[2]+"/"+item.start_date.split("-")[1]+"/"+item.start_date.split("-")[0];
    // }
    // let dateFrom:any=""
    // if(item.date_from!=null && item.date_from!=""){
    //   dateFrom=item.date_from.split("-")[2]+"/"+item.date_from.split("-")[1]+"/"+item.date_from.split("-")[0];
    // }
    if (this.dataCntrl.permit_type.can_specify_duration) {
      if (parseInt(item.noOfDays) > this.max_limit) {
        this.pageload = false;
        return this.toastService.error(
          "Number of Days Should not exceed the limit ",
          "" + this.max_limit
        );
      }
    }

    let newDate1;
    //console.log(item.date_license_expiry);
    if (!item.date_license_expiry) {
      item.date_license_expiry = null;
    }
    if (!item.start_date) {
      item.start_date = null;
    }
    if (item.date_license_expiry != null) {
      let date = item.date_license_expiry.split("/");
      let day = parseInt(date[0], 10);
      let month = parseInt(date[1], 10);
      let year = parseInt(date[2], 10);
      let newDate = year + "/" + month + "/" + day;
      newDate1 = new Date(newDate);
      newDate1.setDate(newDate1.getDate() + 1);
    }
    let newDate2;
    if (item.start_date != null) {
      let date2 = item.start_date.split("/");
      let day2 = parseInt(date2[0], 10);
      let month2 = parseInt(date2[1], 10);
      let year2 = parseInt(date2[2], 10);
      let newDate10 = year2 + "/" + month2 + "/" + day2;
      newDate2 = new Date(newDate10);
      newDate2.setDate(newDate2.getDate() + 1);
    }
    this.dataCntrl.permits.forEach((permit) => {
      if (permit.id == item.permit_id) {
        // permit.id = item.permit_id;
        permit.date_11 = newDate2;
        permit.number_passengers = item.number_passengers;

        this.updatePermitStartDate(permit, item.noOfDays);
        return false;
      }
    });

    let object = {
      id: item.id,
      vehicle_type_id: item.vehicle_type_id,
      vehicle_type: item.vehicle_type,
      vehicle_make_id: item.vehicle_make_id,
      vehicle_make: item.vehicle_make,
      is_current: true,
      registration_number: item.registration_number,
      seating_capacity: item.seating_capacity,
      number_passengers: item.number_passengers,
      gvn: item.gvn,
      vin: item.vin,
      permit_id: item.permit_id,
      date_license_expiry: newDate1, // this.datePipe.transform(item.date_license_expiry),
      start_date: newDate2, // this.datePipe.transform(item.start_date),
      // date_from:dateFrom,
      date_modified: new Date(),
      date_created: new Date(),
      user_modified: (item.user_created =
        environment.authWebApi.userData.User.FirstName),
      editMode: true,
    };
    // object.date_license_expiry= this.datePipe.transform(item.date_license_expiry);
    // object.start_date=this.datePipe.transform(item.start_date);

    this.dataCntrl.vehicles = [];
    if (item.id == -1) {
      let check = this.listvehicles.filter(
        (x) =>
          x.id != -1 &&
          x.registration_number == item.registration_number &&
          x.registration_number != ""
      );
      if (check.length) {
        //console.log(check);
        this.pageload = false;
        return this.toastService.error(
          "Vehicle Already Exists! Please Enter A Different Vehicle.",
          "Vehicle Registration Number"
        );
      }

      if (this.dataCntrl.permittype.temp_long_ind === 2) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Start Date Is Required.",
            "Start Date"
          );
        }

        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Vehicle Type Is Required.",
            "Vehicle Type"
          );
        }
      }
      // if(this.dataCntrl.permittype.freight_passenger_ind === 2){

      //         if(!object.start_date){
      //           // return this.alertError('Start Date Is Required.')
      //           return this.toastr.warning('Start Date Is Required.','Start Date')
      //         }
      //         if(!object.vehicle_type){
      //           // return this.alertError('Vehicle Type Is Required.')
      //           return this.toastr.warning('Vehicle Type Is Required.','Vehicle Type')
      //         }
      //         if(!object.seating_capacity){
      //           // return this.alertError('Vehicle Seating Capacity Is Required.')
      //           return this.toastr.warning('Vehicle Seating Capacity Is Required.','Vehicle Seating Capacity')
      //         }

      // }
      if (this.dataCntrl.permittype.temp_long_ind === 1) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Start Date Is Required.",
            "Start Date"
          );
        }
        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Vehicle Type Is Required.",
            "Vehicle Type"
          );
        }
        if (!item.withoutVehicle) {
          if (!object.registration_number) {
            // return this.alertError('Vehicle Registration Number Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "Vehicle Registration Number Is Required.",
              "Vehicle Registration Number"
            );
          }

          if (!object.gvn) {
            // return this.alertError('Vehicle GVM Is Required.');
            this.pageload = false;
            return this.toastService.error(
              "Vehicle GVM Is Required.",
              "Vehicle GVM"
            );
          }
          if (!object.vin) {
            // return this.alertError('Vehicle VIN Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "Vehicle VIN Is Required.",
              "Vehicle VIN"
            );
          }
          if (object.vin.length !== 17) {
            // return this.alertError('Vehicle VIN Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "VIN should be 17 alphanumeric characters.",
              "Vehicle VIN"
            );
          }
          if (
            object.date_license_expiry === null ||
            object.date_license_expiry === undefined
          ) {
            // return this.alertError('Date License Expiry Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "Date License Expiry Is Required.",
              "Date License Expiry"
            );
          }
        }
        // if(!object.date_from){
        //   return this.toastr.warning('Date From Is Required.','Date From')

        // }
      }

      this.dataCntrl.formValid = true;
      const index: number = this.listvehicles.indexOf(item);
      this.listvehicles[index] = item;
      //save vehicle
      this.pageload = true;

      if (item.withoutVehicle) {
        object["noOfDays"] = 14;
      }

      if (getIndex == 0) {
        this.dataCntrl.permits.forEach((permit) => {
          if (permit.id == item.permit_id) {
            permit.date_11 = object.start_date;
            permit.number_passengers = object.number_passengers;
            this.permitSevc
              .putAppPermit(permit, object["noOfDays"])
              .subscribe((result: any) => {
                //console.log(result);
                //  this.dataCntrl.permit = result;

                object.permit_id = result.id;
                //console.log(object.permit_id);
                this.vehicleService.updateVehicle(object).subscribe(
                  (result) => {
                    setTimeout(() => {
                      this.intializeVehicles();
                    }, 400);
                    //console.log(result);
                    // this.dataCntrl.vehicles = result;
                    this.toastService.success(
                      "Saved Vehicle Successfully",
                      "Vehicle"
                    );
                    const i: number = this.listvehicles.indexOf(item);
                    if (i !== -1) {
                      this.listvehicles[i].editMode = false;
                    }

                    const index: number = this.listvehicles.indexOf(item);
                    // if(index!=null && index!=undefined  && index!=-1){
                    //   this.listvehicles[index].id=result.id;
                    // }
                    this.dataCntrl.vehicles = this.listvehicles;
                    //  this.updateVehiclelist(result);
                  },
                  (error) => {
                    this.pageload = false;
                    // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                    this.toastService.error(
                      "Failed to save application. If the problem persist, please contact system administrator.",
                      "Vehicle"
                    );

                    return;
                  }
                );
              });
          }
        });
      } else {
        this.dataCntrl.permits.forEach((permit) => {
          if (permit.id == item.permit_id) {
            this.permitSevc
              .postAppPermit(permit, object["noOfDays"])
              .subscribe((result: any) => {
                //console.log(result);
                //  this.dataCntrl.permit = result;
                this.updatePermit(result);
                object.permit_id = result.id;
                //console.log(object.permit_id);
                this.vehicleService.updateVehicle(object).subscribe(
                  (result) => {
                    setTimeout(() => {
                      this.intializeVehicles();
                    }, 400);
                    //console.log(result);
                    // this.dataCntrl.vehicles = result;
                    this.toastService.success(
                      "Saved Vehicle Successfully",
                      "Vehicle"
                    );
                    const i: number = this.listvehicles.indexOf(item);
                    if (i !== -1) {
                      this.listvehicles[i].editMode = false;
                    }

                    // if(index!=null && index!=undefined  && index!=-1){
                    //   this.listvehicles[index].id=result.id;
                    // }
                    this.dataCntrl.vehicles = this.listvehicles;
                    //  this.updateVehiclelist(result);
                  },
                  (error) => {
                    this.pageload = false;
                    // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                    this.toastService.error(
                      "Failed to save application. If the problem persist, please contact system administrator.",
                      "Vehicle"
                    );

                    return;
                  }
                );
              });
          }
        });
      }
    } else {
      if (this.dataCntrl.permit_type.temp_long_ind === 2) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Start Date Is Required.",
            "Start Date"
          );
        }
        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Vehicle Type Is Required.",
            "Vehicle Type"
          );
        }
      }
      // if(this.dataCntrl.permittype.freight_passenger_ind === 2){
      //   if(!object.start_date){
      //     // return this.alertError('Start Date Is Required.')
      //     return this.toastr.warning('Start Date Is Required.','Start Date')
      //   }
      //   if(!object.vehicle_type){
      //     // return this.alertError('Vehicle Type Is Required.')
      //     return this.toastr.warning('Vehicle Type Is Required.','Vehicle Type')
      //   }
      //   if(!object.seating_capacity){
      //     // return this.alertError('Vehicle Seating Capacity Is Required.')
      //     return this.toastr.warning('Vehicle Seating Capacity Is Required.','Vehicle Seating Capacity')
      //   }

      // }
      if (this.dataCntrl.permit_type.temp_long_ind === 1) {
        if (object.start_date === null || object.start_date === undefined) {
          // return this.alertError('Start Date Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Start Date Is Required.",
            "Start Date"
          );
        }
        if (!object.vehicle_type) {
          // return this.alertError('Vehicle Type Is Required.')
          this.pageload = false;
          return this.toastService.error(
            "Vehicle Type Is Required.",
            "Vehicle Type"
          );
        }
        if (!item.withoutVehicle) {
          if (!object.registration_number) {
            // return this.alertError('Vehicle Registration Number Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "Vehicle Registration Number Is Required.",
              "Vehicle Registration Number"
            );
          }
          // if(!object.seating_capacity){
          //   return this.toastr.warning('Vehicle Seating Capacity Is Required.','Vehicle Seating Capacity')
          // }
          if (!object.gvn) {
            // return this.alertError('Vehicle GVN Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "Vehicle GVM Is Required.",
              "Vehicle GVM"
            );
          }
          if (!object.vin) {
            // return this.alertError('Vehicle VIN Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "Vehicle VIN Is Required.",
              "Vehicle VIN"
            );
          }
          // if(object.vin.length !== 17){
          //   // return this.alertError('Vehicle VIN Is Required.')
          //   this.pageload = false;
          //   return this.toastr.warning('VIN should be 17 alphanumeric characters.','Vehicle VIN')
          // }
          if (
            object.date_license_expiry === null ||
            object.date_license_expiry === undefined
          ) {
            // return this.alertError('Date License Expiry Is Required.')
            this.pageload = false;
            return this.toastService.error(
              "Date License Expiry Is Required.",
              "Date License Expiry"
            );
          }
        }
        // if(!object.date_from){
        //   return this.toastr.warning('Date From Is Required.','Date From')

        // }
      }

      this.dataCntrl.formValid = true;
      const index: number = this.listvehicles.indexOf(item);

      this.listvehicles[index] = item;

      //save vehicle
      this.pageload = true;

      //Start Date update
      if (this.listvehicles.length > 0) {
        if (this.dataCntrl.permit_type.one_start_date_reqd === true) {
          if (index === 0) {
            for (let i = 0; i < this.listvehicles.length; i++) {
              this.listvehicles[i].start_date = object.start_date;

              let date = this.listvehicles[i].date_license_expiry.split("/");
              let day = parseInt(date[0], 10);
              let month = parseInt(date[1], 10);
              let year = parseInt(date[2], 10);
              let newDate = year + "/" + month + "/" + day;
              newDate1 = new Date(newDate);
              newDate1.setDate(newDate1.getDate() + 1);

              this.listvehicles[i].date_license_expiry = newDate1;
            }
            //console.log(this.listvehicles)
            this.vehicleService
              .postVehicleStartDate(this.listvehicles)
              .subscribe(
                (x) => {
                  //console.log(x);
                  this.toastService.success(
                    "Saved Vehicle Successfully",
                    "Vehicle"
                  );
                  // this.getSavedVehicleByPermit();
                  const i: number = this.listvehicles.indexOf(item);
                  if (i !== -1) {
                    this.listvehicles[i].editMode = false;
                  }
                },
                (erro) => {
                  //console.log(erro);
                  return;
                }
              );

            // return this.updateByStartDate(this.listvehicles);
          }
        }
      }
      if (this.dataCntrl.permit_type.one_start_date_reqd === false) {
        //console.log(item)
        let object = {
          id: item.id,
          vehicle_type_id: item.vehicle_type_id,
          vehicle_type: item.vehicle_type,
          vehicle_make_id: item.vehicle_make_id,
          vehicle_make: item.vehicle_make,
          is_current: true,
          registration_number: item.registration_number,
          // seating_capacity: item.seating_capacity,
          number_passengers: item.number_passengers,
          gvn: item.gvn,
          vin: item.vin,
          permit_id: item.permit_id,
          date_license_expiry: newDate1, // this.datePipe.transform(item.date_license_expiry),
          start_date: newDate2, // this.datePipe.transform(item.start_date),
          // date_from:dateFrom,
          date_modified: new Date(),
          date_created: new Date(),
          user_modified: (item.user_created =
            environment.authWebApi.userData.User.FirstName),
          editMode: true,
        };
        // let object = {
        //   id: item.id,
        //   vehicle_type_id: item.vehicle_type_id,
        //   vehicle_type: item.vehicle_type,
        //   vehicle_make_id: this.selectedVMake.id,
        //   vehicle_make: this.selectedVMake.description,
        //   is_current: true,
        //   registration_number: !item.withoutVehicle ? this.eNatisData.registration_number : null,
        //   registration_year: !item.withoutVehicle ? this.eNatisData.registration_year : null,
        //   vehicle_entry_id: !item.withoutVehicle ? this.eNatisData.vehicle_entry_id : null,
        //   vehicle_owner: !item.withoutVehicle ? this.eNatisData.vehicle_owner : null,
        //   vehicle_colour: !item.withoutVehicle ? this.eNatisData.vehicle_colour : null,
        //   vehicle_model: !item.withoutVehicle ? this.eNatisData.vehicle_model : null,
        //   seating_capacity: !item.withoutVehicle ? this.eNatisData.seating_capacity : null,
        //   number_passengers: item.number_passengers,
        //   gvn: !item.withoutVehicle ? this.eNatisData.gvn : null,
        //   vin: !item.withoutVehicle ? this.eNatisData.vin : null,
        //   permit_id: item.permit_id,
        //   noOfDays: item.noOfDays,
        //   date_license_expiry: !item.withoutVehicle ?  this.datePipe.transform(this.eNatisData.date_license_expiry) : newDate1 : null,//newDate1,// this.datePipe.transform(item.date_license_expiry),
        //   start_date: newDate2,// this.datePipe.transform(item.start_date),
        //   // date_from:dateFrom,
        //   date_modified: new Date(),
        //   date_created: new Date(),
        //   user_modified: item.user_created = environment.authWebApi.userData.User.FirstName,
        //   editMode: true
        // }

        this.dataCntrl.permits.forEach((permit) => {
          if (permit.id == item.permit_id) {
            permit.date_11 = object.start_date;
            permit.number_passengers = object.number_passengers;
            permit.id = object.permit_id;

            this.permitSevc
              .putAppPermit(permit, object["noOfDays"])
              .subscribe((prm) => {
                this.permitSevc
                  .upadatePermit(permit)
                  .subscribe((result: any) => {
                    //  this.dataCntrl.permit = result;
                    object.permit_id = result.id;
                    //console.log(object.permit_id);
                    this.vehicleService.updateVehicle(object).subscribe(
                      (result: any) => {
                        // setTimeout(()=>{this.getSavedVehicleByPermit('');},400);
                        //console.log(result);
                        // this.listvehicles.push(result);
                        // this.dataCntrl.vehicles = result;
                        // let days: any = this.noOfDays;
                        // if (result != null) {
                        //   let from_date: any = new Date(result.date_valid_from);
                        //   let to_date: any = new Date(result.date_valid_to);

                        //   if (from_date != undefined && to_date != undefined) {
                        //     days = Math.floor((Date.UTC(to_date.getFullYear(), to_date.getMonth(), to_date.getDate()) - Date.UTC(from_date.getFullYear(), from_date.getMonth(), from_date.getDate())) / (1000 * 60 * 60 * 24));
                        //     //console.log("------+" + days);
                        //   }
                        // }

                        // object['noOfDays'] = days;
                        this.pageload = false;
                        this.toastService.success(
                          "Updated Vehicle Successfully",
                          "Vehicle"
                        );
                        const i: number = this.listvehicles.indexOf(item);
                        if (i !== -1) {
                          this.listvehicles[i].editMode = false;
                        }

                        // if(index!=null && index!=undefined  && index!=-1){
                        //   this.listvehicles[index].id=result.id;
                        // }
                        //  this.updateVehiclelist(result);
                      },
                      (error) => {
                        this.pageload = false;
                        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                        this.toastService.error(
                          "Failed to save application. If the problem persist, please contact system administrator.",
                          "Vehicle"
                        );

                        return;
                      }
                    );
                  });
              });
          }
        });
      }
    }
    // }
  }
}
